// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.numberSearch[data-v-865625d2]  .el-input--small .el-input__inner {\n  line-height: 28px;\n  height: 28px;\n  border: none;\n  padding-left: 0;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
